import { Control, FieldValues, UseFormSetValue } from "react-hook-form";

import { IFormAttributes } from "@ryde/shared";

export interface IUserRoleItem {
  roleId: number;
  siteIds?: number[] | null;
  supplierIds?: number[] | null;
  unitIds?: number[] | null;
  rideTypeIds?: number[] | null;
}

export interface IUserRoleItemForm {
  fieldName: string;
  control?: Control;
  index?: number;
  onEdit?: () => void;
  value?: Partial<IUserRoleItem>;
  setValueOuter?: UseFormSetValue<FieldValues>;
  removeHandler?: (index: number) => void;
  onCancelOuter?: () => void;
  formAttributes?: IFormAttributes | null;
  onEditStart?: () => void;
  onEditEnd?: () => void;
}

export const emptyUserRole = {} as IUserRoleItem;

export const userRoleFormFieldNames: (keyof IUserRoleItem)[] = [
  "roleId",
  "siteIds",
  "supplierIds",
  "unitIds",
  "rideTypeIds",
];
